import {Injectable} from '@angular/core';
import {FrameService} from './frame.service';
import OverlayModel from '../../../models/overlay.model';
import {AnimationService} from './animation.service';
import {EasingService} from './easing.service';
import {AnimationProgressInterface} from '../../../interfaces/animation-progress.interface';

@Injectable({
    providedIn: 'root'
})
export class FadeService {

    constructor(private frameService: FrameService,
        private animationService: AnimationService,
        private easingService: EasingService) {
    }

    createFadeInListProgress(overlay: OverlayModel): AnimationProgressInterface {
        const frameService = this.frameService;
        const start = frameService.getRoundFrame(overlay.time.start);
        const end = frameService.getRoundFrame(overlay.time.start + (overlay.transition.start.duration));
        const framesCount = frameService.numberOfFrameInAnimation(end, start);
        const opacity = overlay.transition.start.hasOwnProperty('opacity') ? overlay.transition.start.opacity : 0;
        const progress = (overlay.style.opacity - opacity) / framesCount;
        const animationProgress = {
        } as AnimationProgressInterface;

        let opacityBuffer = opacity;

        animationProgress[start] = opacity;

        for (let i = start + 1; i < end; i++) {
            opacityBuffer += progress;
            animationProgress[i] = opacity
        + this.easingService.calculateProgressByType(overlay.transition.start.type, opacityBuffer)
        * (overlay.style.opacity - opacity);
        }

        animationProgress[end] = overlay.style.opacity;

        return animationProgress;
    }

    createFadeOutListProgress(overlay: OverlayModel): AnimationProgressInterface {
        const frameService = this.frameService;
        const start = frameService.getRoundFrame(overlay.time.end - (overlay.transition.end.duration));
        const end = frameService.getRoundFrame(overlay.time.end);
        const framesCount = frameService.numberOfFrameInAnimation(end, start);
        const opacity = overlay.transition.end.hasOwnProperty('opacity') ? overlay.transition.end.opacity : 0;
        const progress = (overlay.style.opacity - opacity) / framesCount;
        const animationProgress = {
        } as AnimationProgressInterface;

        let opacityBuffer = overlay.style.opacity;

        animationProgress[start] = overlay.style.opacity;

        for (let i = start + 1; i < end; i++) {
            opacityBuffer -= progress;
            animationProgress[i] = opacity
        + this.easingService.calculateProgressByType(overlay.transition.end.type, opacityBuffer)
        * (overlay.style.opacity - opacity);

        }
        animationProgress[end] = opacity;

        return animationProgress;
    }
}
